/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";

import { Outlet, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import AddNewUser from "./Components/Core/RadicalFocusSetting/UserManagement/AddNewUser";

import { RootState } from "./Store/store";
import { isAuth } from "./Library/Utils/auth";
import { getAllPersonList } from "./Network/Core/objective";
import { setUsersData, setUsersLoading } from "./Store/Reducers/masterData";

// eslint-disable-next-line react/function-component-definition
export default function PrivteRoutes() {
  const dispatch = useDispatch();
  const inviteUser = useSelector((state: RootState) => state.inviteUserReducer);

  const [addNewUserOpen, setAddNewUserOpen] = useState<boolean>(false);

  useEffect(() => {
    setAddNewUserOpen(inviteUser?.isDrawerOpen);
  }, [inviteUser?.isDrawerOpen]);

  // Another tab logged out (or a reset / invite link ended the session on
  // this browser): send this tab to sign-in too instead of leaving the old
  // user's pages up. Another tab signed in as someone else: the cookies are
  // theirs now, so this tab would show the old user while every request ran
  // as the new one; reload it as the new user. A full load, like the 401
  // handler, drops the store.
  useEffect(() => {
    const storedUserId = (stored: string | null) => {
      try {
        return JSON.parse(stored || "null")?.id ?? null;
      } catch {
        return null;
      }
    };
    const onStorage = (event: StorageEvent) => {
      if (
        (event.key === null || event.key === "isAuthenticated") &&
        !isAuth()
      ) {
        window.location.replace(`${window.location.origin}/signin`);
        return;
      }
      // Profile edits and company switches rewrite "user" too; only a
      // different id means a different login.
      const before = event.key === "user" ? storedUserId(event.oldValue) : null;
      const after = event.key === "user" ? storedUserId(event.newValue) : null;
      if (before && after && before !== after) {
        window.location.replace(`${window.location.origin}/`);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    if (isAuth()) {
      const fetchGlobalData = async () => {
        try {
          dispatch(setUsersLoading(true));
          // Fetch all users using a high page size to ensure we get all records
          const res = await getAllPersonList(1, 5000, "", "first_name");
          if (res?.data?.data?.results) {
            dispatch(setUsersData(res.data.data.results));
          }
        } catch (error) {
          console.error("Failed to fetch global user data", error);
        } finally {
          dispatch(setUsersLoading(false));
        }
      };
      fetchGlobalData();
    }
  }, [dispatch]);

  return isAuth() === true ? (
    <>
      <Outlet />
      {/* Add User Drawer Start */}
      <AddNewUser addNewUserOpen={addNewUserOpen} />
      {/* Add User Drawer End */}
    </>
  ) : (
    <Navigate to="/signin" />
  );
}
